import { BookOpen, BadgeCheck, Gift, ShieldCheck } from "lucide-react";

const items = [
  { icon: BookOpen, label: "28 curated free programs" },
  { icon: Gift, label: "No registration required" },
  { icon: BadgeCheck, label: "DPIIT Recognised initiative" },
  { icon: ShieldCheck, label: "Curated from official government sources" },
];

export const TrustStrip = () => {
  return (
    <section aria-label="Trust and credibility" className="border-y bg-muted/30 py-6">
      <div className="container">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map(({ icon: Icon, label }) => (
            <li
              key={label}
              className="flex items-center gap-3 text-sm font-medium text-foreground"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Icon className="h-4 w-4" />
              </span>
              <span>{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};